import React from 'react';
import { connect } from 'react-redux';
import {
  Panel,
  Button,
  Row,
  Col
} from 'react-bootstrap';
import {
  Container,
  PlanForm,
  ConfirmationPrompt,
  LoadingSpinner
} from 'components';
import { requestCreatePlan, push } from 'actions';
import _ from 'lodash';

class CreatePlan extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show_cancel_new_plan_prompt: false
    };

    this.confirmCancelNewPlan = this.confirmCancelNewPlan.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  confirmCancelNewPlan() {
    this.setState({ show_cancel_new_plan_prompt: false });
    this.props.push('/sales-site/plans');
  }
  handleSave(plan) {
    this.props.requestCreatePlan(plan);
  }
  render() {
    return (
      <Container title='Create Plan'>
        <div className='create-plan-container'>
          <Panel header='Create a New Plan'>
            <PlanForm
              handleSave={this.handleSave}
              handleCancel={() => this.setState({ show_cancel_new_plan_prompt: true })}
            />
          </Panel>
        </div>

        {this.state.show_cancel_new_plan_prompt ? (
          <ConfirmationPrompt
            key='show_cancel_new_plan_prompt'
            show_condition={this.state.show_cancel_new_plan_prompt}
            handleCancelPrompt={() => this.setState({ show_cancel_new_plan_prompt: false })}
            handleConfirmPrompt={this.confirmCancelNewPlan}
            type='danger'
            title='Cancel Plan Creation?'
            body='Are you sure you want to cancel creating a new plan? All changes will be lost'
            bsSize='small'
            confirm_button_text='Confirm'
            cancel_button_text='Cancel'
          />
        ) : null}
      </Container>
    )
  }
}

const mapStateToProps = ({ plans, features }) => ({ plans, features });

export default connect(mapStateToProps, { requestCreatePlan, push })(CreatePlan);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/plans/create-plan.js